import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

function LazyLoader({ children, loadingComponent, offset, threshold, id }) {
  const [isVisible, setIsVisible] = useState(false);
  const options = {
    rootMargin: typeof offset === 'number' ? `${offset}px` : offset || '0px',
    threshold: threshold || 0,
  };
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      });
    }, options);

    observer.observe(document.getElementById(id));

    return () => {
      observer.disconnect();
    };
  }, []);

  return <div id={id}>{isVisible ? children : loadingComponent}</div>;
}
LazyLoader.propTypes = {
  children: PropTypes.node,
  loadingComponent: PropTypes.node,
  offset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  threshold: PropTypes.number,
  id: PropTypes.string,
};
LazyLoader.defaultProps = {
  children: null,
  loadingComponent: null,
  offset: 0,
  threshold: 0,
  id: 'lazy-load',
};

export default LazyLoader;
